import { api } from '../../../helpers'
import { appConstants } from '../../../constants'

export const getArticleCategory = () => {
  return dispatch => {
    dispatch(loadArticleRequest())
    api.get('web/article?limit=10')
      .then((res) => {
        const { data: articleCategory, success, message } = res.data
        if (success === true) {
          dispatch(loadArticleSuccess(articleCategory))
        } else {
          dispatch(loadArticleFailed(message))
        }
      })
      .catch((message) => dispatch(loadArticleFailed(message)))
  }
}

const loadArticleRequest = () => ({
  type: appConstants.GET_ARTICLE_CATEGORY_REQUEST
})

const loadArticleSuccess = (articleCategory) => ({
  type: appConstants.GET_ARTICLE_CATEGORY_SUCCESS,
  payload: { articleCategory }
})

const loadArticleFailed = (message) => ({
  type: appConstants.GET_ARTICLE_CATEGORY_FAILED,
  payload: { message }
})
